import { todayInIsrael } from "@/lib/dateUtils";

export type FirstWeeksStepId = "joined" | "first_lesson" | "reminder_time" | "second_lesson";

export interface FirstWeeksStep {
  id: FirstWeeksStepId;
  label: string;
  done: boolean;
}

/** The four steps of the "first two weeks" Home card, in display order. */
export function computeFirstWeeksSteps(a: { lessonsCompleted: number; hasReminderTime: boolean }): {
  steps: FirstWeeksStep[];
  doneCount: number;
} {
  const steps: FirstWeeksStep[] = [
    { id: "joined", label: "הצטרפת", done: true },
    { id: "first_lesson", label: "שיעור ראשון", done: a.lessonsCompleted >= 1 },
    { id: "reminder_time", label: "בחירת שעה לתזכורת", done: a.hasReminderTime },
    { id: "second_lesson", label: "שיעור שני", done: a.lessonsCompleted >= 2 },
  ];
  return { steps, doneCount: steps.filter((s) => s.done).length };
}

const WINDOW_MS = 14 * 24 * 60 * 60 * 1000;

/**
 * The card lives for the account's first 14 days, measured in elapsed
 * milliseconds (exactly 14 days is still visible; DST cannot shift it).
 * Once all four steps are done it stays for the rest of that Israel day only.
 */
export function isFirstWeeksCardVisible(a: {
  createdAt: string | null;
  now: Date;
  dismissed: boolean;
  allDoneDay: string | null;
}): boolean {
  if (!a.createdAt) return false;
  const createdMs = Date.parse(a.createdAt);
  if (Number.isNaN(createdMs)) return false;
  if (a.now.getTime() - createdMs > WINDOW_MS) return false;
  if (a.dismissed) return false;
  if (a.allDoneDay) return todayInIsrael(a.now) === a.allDoneDay;
  return true;
}

/** `first_weeks_card_shown` is sent at most once per Israel day. */
export function shouldTrackShown(lastShownDay: string | null, now: Date): boolean {
  return lastShownDay !== todayInIsrael(now);
}
